/**
 * Ballot validation states used during tallying.
 * Determines whether a ballot can be counted.
 */
export const ballotState = {
    /** Not yet evaluated */
    unassessed: 0,
    /** Passes all validation checks */
    valid: 1,
    /** Failed validation (duplicates, wrong count) */
    invalid: 2,
    /** Requires manual review */
    undetermined: 3,
} as const;

/**
 * Types of elections supported by the system.
 */
export const electionType = {
    /** Invalid/unknown election type */
    invalid: 0,
    /** Instant runoff voting with ranked choices */
    adhoc: 1,
    /** Standard plurality voting */
    normal: 2
}

/**
 * UI display modes for showing candidate lists.
 */
export const listType = {
    /** Button-based selection */
    button: 0,
    /** List-based selection */
    list: 1,
    /** Normal/standard display */
    normal: 2
}

export const orderType = {
    as_typed: 0,
    random: 1,
    alphabetical: 2
}

export const electionState = {
    ended: 0,
    begun: 1,
    finished: 2,
    /** Online voting closed; teller entry and adjudication still permitted before final tally */
    stopped: 3,
}

export const electionError = {
    noError: 0,
    noCode: 1,
    invalidCode: 2,
    invalidCodeToken: 3
}

export const normalElectionType = {
    invalid: 0,
    chip: 1,
    table: 2,
    ballot: 3
}

// Greater than 100 are for Ad Hoc types
export const electionPurposeType = {
    invalid: 0,
    lsa: 1,
    rbc: 2,
    nsa: 3,
    unit: 4,
    byelection: 5,
    tie: 101,
    office: 102,
    immediate: 103
}

export const electeeMatchState = {
    invalid: 0,
    noMatch: 1,
    oneExact: 2,
    oneNotExact: 3,
    distinct: 4,
    few: 5,
    tooMany: 6
}
